import {useQuery} from 'react-query';
import {ReportGeneratorStore} from './stores/ReportGeneratorStore';
import {getReportColumns, getReportData} from './services/service';
import {useEffect} from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';

export const useFieldsQuery = (reportsScreenStore: ReportGeneratorStore) => {
    const {currentReport, session} = reportsScreenStore;
    const {
        nodeId,
        reportId,
        isNew,
        isDirty,
        duplicateId,
        columns,
        setReportData,
        resetIsNew,
        initSelectedNodes
    } = currentReport;

    const {
        isLoading: isLoadingReportData,
        isFetching: isFetchingReportData,
        data: reportData
    } = useQuery(['currentReport', reportId, session], () => getReportData(reportId), {
        enabled: !!reportId
    });

    const {isLoading: isLoadingFields, data: fields} = useQuery(
        ['formFields', nodeId, reportId, session],
        () => getReportColumns(nodeId, duplicateId || reportId),
        {
            enabled: !!columns || isNew || !!duplicateId,
            select: data => ({
                all: data.all.sort((a, b) => a.Title.localeCompare(b.Title)),
                selected: data.selected?.sort(
                    (a, b) =>
                        columns?.findIndex(item => item.NodeId === a.NodeId) -
                        columns?.findIndex(item => item.NodeId === b.NodeId)
                )
            }),
            onSuccess(data) {
                initSelectedNodes(new Map(data.selected.map(col => [col.NodeId, col])));
            }
        }
    );

    useEffect(() => {
        if (reportData && !isDirty && !isFetchingReportData) {
            const reportDataWithSortType = {
                ...reportData,
                Columns: reportData.Columns?.map(col => ({
                    ...col,
                    SortType: col.Sort
                        ? col.SortType
                        : priority.netitems.nrest.RepColSortType.RepColSortType_Ascending
                }))
            };
            setReportData(reportDataWithSortType);
            isNew && resetIsNew();
        }
    }, [reportData]);

    return {
        isLoadingReportData: isLoadingReportData,
        isLoadingFields,
        fields
    };
};
